import * as z from "zod";
import { mutator } from "./mutator";

export const deleteAuditLogDestinationSchema = z.object({
  id: z.string(),
});

export const deleteAuditLogDestination = mutator({
  schema: deleteAuditLogDestinationSchema,
  resolve: {
    destination: { kind: "auditLogDestination", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:audit_logs_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { destination } }) => {
    await tx.mutate.auditLogDestinations.delete({ id: destination.id });
  },
});
